import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFeature } from '../../services/featureConfigContext';

function InstallPrompt() {
  const { t } = useTranslation();
  const { enabled: pwaEnabled } = useFeature('pwa');
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('psy-trainer-pwa-dismissed') === '1'
  );

  useEffect(() => {
    const handler = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!pwaEnabled || !deferredPrompt || dismissed) {
    return null;
  }

  const handleInstall = async () => {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setDismissed(true);
    localStorage.setItem('psy-trainer-pwa-dismissed', '1');
  };

  return (
    <button type="button" className="ui-btn ui-btn-ghost ui-btn-sm" onClick={handleInstall}>
      {t('common.installApp')}
    </button>
  );
}

export default InstallPrompt;
